import React, { memo } from 'react';
import './CommonButton.css';

function CommonButton({
  title,
  onPress,
  customClassName,
  outlined = false,
  disabled = false,
  isLoading = false,
  type = 'button',
}) {

  return (
    <button
      type={type}
      onClick={onPress}
      className={`common-button ${outlined ? 'outlined' : 'contained'} ${disabled ? 'disabled' : ''} ${customClassName || ''}`}
      disabled={disabled}
    >
      <span className="common-button-text">
        {isLoading ? 'Loading…' : title}
      </span>
    </button>
  );
}

export default memo(CommonButton); 